import { createFileRoute, redirect } from '@tanstack/react-router'

// The standalone articles index duplicated Learn's Guides tab with a stale
// layout; consolidated in the 2026-06 IA cleanup (TD-016). Article detail
// pages (/articles/$slug) are unaffected.
export const Route = createFileRoute('/_auth/articles/')({
  beforeLoad: () => {
    throw redirect({ to: '/learn', search: { tab: 'Guides', tour: undefined, invitationcode: undefined, __clerk_ticket: undefined }, replace: true })
  },
})
